import React from 'react';

import normalizeImageUrl from '../../../../lib/utils/image/normalizeImageUrl';

import ImgCover, {
  ImgCoverStyle,
} from '../../../../components/ui/img/ImgCover';

interface IHeaderImageProps {
  className: string;
  src: string;
  title: string;
}

function HeaderImage({ className, src, title }: IHeaderImageProps) {
  return (
    <div className={className}>
      <ImgCover
        data-hook="main.header.image"
        coverStyle={ImgCoverStyle.SQUARE}
        src={normalizeImageUrl(src)}
        title={title}
      />
    </div>
  );
}

export default HeaderImage;
